import {Box, Typography} from "@mui/material";

export default function Features({features}) {
    return (
        <Box sx={{marginTop: "10px" }}>
                <Typography display='inline' sx={{fontWeight: "bold", paddingRight: "0.5em"}} variant="body2">Features:</Typography>
                <Typography variant="body2" display='inline' sx={{}}>{features.map((f) => f.name).join(', ')}</Typography>
        </Box>
    );
}